import { isVideoStation } from '../helpers';
import { useStations } from './useStations';
import { Station } from '@app/core/types/stations';

export function useVideoStations(): readonly Station[] {
  return useStations(isVideoStation);
}
